module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.link,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.type),
      expression: "curInput.link.type"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择类型"
    },
    domProps: {
      "value": (_vm.curInput.link.type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.type = $event
      }
    }
  }, _vm._l((_vm.typeOption), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.link.type == _vm.CASCADER_SELF),
      expression: "curInput.link.type == CASCADER_SELF"
    }],
    attrs: {
      "label": "表单",
      "prop": "model_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.model_id),
      expression: "curInput.link.model_id"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择表单"
    },
    domProps: {
      "value": (_vm.curInput.link.model_id)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.model_id = $event
      }
    }
  }, _vm._l((_vm.formList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.title + '(' + item.name + ')',
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.link.type == _vm.CASCADER_SELF),
      expression: "curInput.link.type == CASCADER_SELF"
    }],
    attrs: {
      "label": "选择级联关联字段",
      "prop": "link_field_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.link_field_id),
      expression: "curInput.link.link_field_id"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择级联关联字段"
    },
    domProps: {
      "value": (_vm.curInput.link.link_field_id)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.link_field_id = $event
      }
    }
  }, _vm._l((_vm.fieldList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.field_id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.link.type == _vm.CASCADER_SELF),
      expression: "curInput.link.type == CASCADER_SELF"
    }],
    attrs: {
      "label": "选择显示名称字段",
      "prop": "show_field_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.show_field_id),
      expression: "curInput.link.show_field_id"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择显示名称字段"
    },
    domProps: {
      "value": (_vm.curInput.link.show_field_id)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.show_field_id = $event
      }
    }
  }, _vm._l((_vm.fieldList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.field_id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.link.type == _vm.CASCADER_SELF),
      expression: "curInput.link.type == CASCADER_SELF"
    }],
    attrs: {
      "label": "筛选条件",
      "prop": "filter"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.link.filter),
      expression: "curInput.link.filter",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.curInput.link.filter)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.filter = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("支持等于==，不等于<>，大于>，小于<逻辑判断")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.link.type == _vm.CASCADER_PROVINCE),
      expression: "curInput.link.type == CASCADER_PROVINCE"
    }],
    attrs: {
      "label": "区域限制",
      "prop": "area_limit"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.area_limit),
      expression: "curInput.link.area_limit"
    }],
    domProps: {
      "value": (_vm.curInput.link.area_limit)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.area_limit = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.link.type == _vm.CASCADER_PROVINCE && _vm.curInput.link.area_limit == 1),
      expression: "curInput.link.type == CASCADER_PROVINCE && curInput.link.area_limit == 1"
    }],
    attrs: {
      "prop": "area_config"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.area_config),
      expression: "curInput.link.area_config"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "multiple": "",
      "placeholder": "区域限制"
    },
    domProps: {
      "value": (_vm.curInput.link.area_config)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.area_config = $event
      }
    }
  }, _vm._l((_vm.cityData), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选中结果显示",
      "prop": "result_show"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.result_show),
      expression: "curInput.link.result_show"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择选中结果显示"
    },
    domProps: {
      "value": (_vm.curInput.link.result_show)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.result_show = $event
      }
    }
  }, _vm._l((_vm.resultShowOption), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否有搜索功能",
      "prop": "has_search"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.link.has_search),
      expression: "curInput.link.has_search"
    }],
    domProps: {
      "value": (_vm.curInput.link.has_search)
    },
    on: {
      "input": function($event) {
        _vm.curInput.link.has_search = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5128d23e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/cascaderConfig.vue
// module id = 1863
// module chunks = 2